export default {
  
  en: {
    billDate: 'Bill date',
    dataCaliber: 'Data caliber',
    hierarchyObject: 'Hierarchy object',
    departmentName: 'Department Name',
    collectionStage: 'Level',
    groupName: 'Team',
    collectorName: 'Name',
    date: 'Date',
    department: 'Department',
    orderNum: ' Orders',
    repaidOrders: 'Repaid orders(incl extensions) ',
    orderAmount: 'Due Date Amount-Total',
    yiHuanAmount: 'Due date amount-repaid',
    huanKuanCountRate: 'Repayment rate-order',
    huanKuanAmountRate: 'Repayment rate-amount',
    shouRiCount: 'First day success',
    zhiNaJinAmount: 'Total amount of late fee',
    zhiNaJinPayAmount: 'Recovery late fee',
    zhiNaJinPayRate: 'Recovery rate of late fees',
    cuiJiOrderCount: 'Recorded order',
    cuiJiOverRate: ' Record completion rate',
    cuiJiCount: 'Record times',
    cuiJiCountPreOrder: 'Average times per order',
    anDate: 'Date',
    total: 'total',
    orderCount: 'hand orders',
    yiHuanCount: 'returned orders',
    yiHuanRate: 'returned rate'
  }
}
